// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"104":"0c3817a0","426":"0c3817a0","511":"0c3817a0"}[chunkId] + ".chunk.css";
};